import React from 'react';

const AuthLayout = ({ children, theme }) => {
  return (
    <div className={`app-container ${theme}`} data-bs-theme={theme}>
      {/* For auth routes the top navigation is hidden; remove the top padding */}
      <main className="main-content topbar-hidden">
        <div className="page-content">{children}</div>
      </main>
    </div>
  );
};

export default AuthLayout;